/** autoFocus is recommended for accessibility in order
 * to have the focus directly on the close button
 */
/* eslint-disable jsx-a11y/no-autofocus */
// React
import { ReactElement, useRef } from 'react';
// Modules
import { OverlayContainer, OverlayProvider, useOverlay, useModal } from '@react-aria/overlays';
import { useDialog } from '@react-aria/dialog';
import { FocusScope } from '@react-aria/focus';
// Types
import { IconsEnum } from '@utmb/types/icons';
import { HorizontalAlignEnum, ModalView, VerticalAlignEnum } from '@utmb/types/modal';
// Design System
import { Icon } from '@utmb/design-system/icons/Icon';
// Styles
import styles from './modal.module.scss';

export const Modal = (props: ModalView): ReactElement => {
    const { children, isOpen, onClose, maxWidth = 1010, vAlign = VerticalAlignEnum.CENTER, hAlign = HorizontalAlignEnum.CENTER } = props;

    const ref = useRef(null);
    const { overlayProps, underlayProps } = useOverlay(props as any, ref);
    const { modalProps } = useModal();
    const { dialogProps } = useDialog(props as any, ref);

    return (
        <OverlayProvider>
            {isOpen && (
                <OverlayContainer id="myUtmbModal">
                    <div
                        {...underlayProps}
                        className={styles.container}
                        style={{
                            alignItems: vAlign,
                            justifyContent: hAlign,
                        }}
                    >
                        <FocusScope contain restoreFocus autoFocus>
                            <div {...overlayProps} {...dialogProps} {...modalProps} ref={ref} className={styles.modal} style={{ maxWidth }}>
                                <button onClick={() => onClose(!isOpen)} className={styles.close}>
                                    <Icon variant={IconsEnum.CLOSE} />
                                </button>
                                {children}
                            </div>
                        </FocusScope>
                    </div>
                </OverlayContainer>
            )}
        </OverlayProvider>
    );
};
